import { BookingMode, BookingAvailabilityModeValue } from '@kouto/types';

const bookingAvailabilityModeToBookingMode = (
  bookingAvailabilityMode?: BookingAvailabilityModeValue | null,
): BookingMode => {
  if (!bookingAvailabilityMode) return BookingMode.SHARED;

  return bookingAvailabilityMode === BookingAvailabilityModeValue.PRIVATE_ONLY
    ? BookingMode.PRIVATE
    : BookingMode.SHARED;
};

export default bookingAvailabilityModeToBookingMode;
